// A UrlData row opens at the URL as it was submitted; a row that never had one falls back to the
// stem, which getUrlStemGuess stores scheme- and www-stripped.
export const getUrlDataLink = urlData => {
  const url = urlData?.sampleUrl || urlData?.urlStem;
  if (!url) return null;
  return /^https?:\/\//i.test(url) ? url : `https://${url}`;
};

// Some origins only answer on the www. host, and neither a stem nor a bare submitted URL says which,
// so the queue offers the www. form beside a bare-host link. Null when the link already has it.
// A submitted URL can be an affiliate wrapper (brand.sjv.io/c/…?u=https://kroger.com/…) that the
// stem was unwrapped from, so when the two hosts differ the www. form comes from the stem.
export const getUrlDataWwwLink = urlData => {
  const link = parseUrl(getUrlDataLink(urlData));
  const stem = parseUrl(urlData?.urlStem && `https://${urlData.urlStem}`);
  if (!link || !stem) return null;
  const isLinkOnStemHost = withoutWwwLabel(link.hostname) === withoutWwwLabel(stem.hostname);
  const source = isLinkOnStemHost ? link : stem;
  if (hasWwwLabel(source.hostname)) return isLinkOnStemHost ? null : source.toString();
  source.hostname = `www.${source.hostname}`;
  return source.toString();
};

const parseUrl = url => {
  try {
    return new URL(url);
  } catch {
    return null;
  }
};

// www2.example.com already names a www host; www.www2.example.com would not.
const hasWwwLabel = hostname => /^www\d*\./i.test(hostname);
const withoutWwwLabel = hostname => hostname.replace(/^www\d*\./i, '');
